export interface IModal {
  id: number;
  render: (modal: IModal) => React.ReactNode;
  close: () => void;
  namespace?: string;
}

export interface IModalOpenOptions {
  namespace?: string;
}

export type IModalOpen = (render: (modal: IModal) => React.ReactNode, options?: IModalOpenOptions) => number;
type IModalSubscriber = (modals: IModal[]) => void;
type IModalUnsubscribe = () => void;

let modals: IModal[] = [];
let currentModalId: number = 0;
const subscribers: IModalSubscriber[] = [];

export const subscribe = (subscriber: IModalSubscriber): IModalUnsubscribe => {
  let isSubscribed = true;

  subscribers.push(subscriber);

  return () => {
    if (!isSubscribed) {
      return;
    }

    const index = subscribers.indexOf(subscriber);
    subscribers.splice(index);
    isSubscribed = false;
  };
};

const dispatch = (): void => {
  for (const subscriber of subscribers) {
    subscriber(modals);
  }
};

export const open: IModalOpen = (render, options): number => {
  const id: number = ++currentModalId;
  const modal: IModal = {
    id,
    render,
    close: close.bind(null, id),
    ...options,
  };

  modals = [...modals, modal];
  dispatch();

  return id;
};

export const close = (id: number): void => {
  modals = modals.filter((modal) => modal.id !== id)
  dispatch();
};

export const closeByNamespace = (namespace: string): void => {
  modals = modals.filter((modal) => modal.namespace !== namespace);
  dispatch();
};

export const getModals = (): IModal[] => modals;



// WEBPACK FOOTER //
// ./src/shared/Modal/store.ts